import { ReactElement, useCallback, useEffect, useState } from "react";
import LoadingSpinner from "../shared/LoadingSpinner";
import ArticlesPreview from "./ArticlesPreview";
import { getInactiveArticleList } from "services/ArticleServices";
import { article } from "./ArticleInterfaces";

const InactiveArticles = (): ReactElement =>{    const [articleData, setArticleData] = useState<article[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const getData = useCallback(() => {
        getInactiveArticleList(setArticleData);
        setTimeout(() => { setIsLoading(false); }, 500)
    }, [setArticleData]);

    useEffect(() => {
        getData();
    }, [getData]);

    return <>
        {isLoading && <LoadingSpinner />}
        {
            <ArticlesPreview data={articleData} getData={getData} />
        }
    </>
}

export default InactiveArticles;